import classNames from 'classnames';
import { InputHTMLAttributes, useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';

interface PasswordInputProps {
    name: string;
    placeholder?: string;
    refCallback?: any;
    register?: any;
    className?: string;
    errorText?: string;
}

/* Password Input */
const PasswordInput = ({
    name,
    placeholder,
    refCallback,
    register,
    className,
    errorText,
    ...otherProps
}: PasswordInputProps) => {
    const [showPassword, setShowPassword] = useState<boolean>(false);

    return (
        <>
            <InputGroup className="mb-0">
                <Form.Control
                    type={showPassword ? 'text' : 'password'}
                    placeholder={placeholder}
                    name={name}
                    id={name}
                    as="input"
                    ref={(r: HTMLInputElement) => {
                        if (refCallback) refCallback(r);
                    }}
                    className={className}
                    {...(register ? register(name) : {})}
                    autoComplete={name}
                    {...otherProps}
                />
                {/* <div
                    className={classNames('input-group-text', 'input-group-password', {
                        'show-password': showPassword,
                    })}
                    data-password={showPassword ? 'true' : 'false'}
                >
                    <span
                        className="password-eye"
                        onClick={() => {
                            setShowPassword(!showPassword);
                        }}
                    ></span>
                </div> */}
            </InputGroup>
        </>
    );
};

interface FormInputProps extends InputHTMLAttributes<HTMLInputElement> {
    label?: string;
    type?: string;
    name: string;
    placeholder?: string;
    register?: any;
    className?: string;
    labelClassName?: string;
    containerClass?: string;
    refCallback?: any;
    children?: any;
    rows?: string;
    errorText?: string;
}

const FormInput = ({
    label,
    type,
    name,
    placeholder,
    register,
    className,
    labelClassName,
    containerClass,
    refCallback,
    children,
    rows,
    errorText,
    ...otherProps
}: FormInputProps) => {
    // handle input type
    const comp = type === 'textarea' ? 'textarea' : (type === 'select' ? 'select' : 'input');

    return (
        <>
            {type === 'hidden' ? (
                <input type={type} name={name} {...(register ? register(name) : {})} {...otherProps} />
            ) : (
                <>
                    {type === 'password' ? (
                        <>
                            <Form.Group className={containerClass}>
                                {label ? (
                                    <>
                                        {' '}
                                        <Form.Label className={labelClassName}>{label}</Form.Label> {children}{' '}
                                    </>
                                ) : null}
                                <PasswordInput
                                    name={name}
                                    placeholder={placeholder}
                                    refCallback={refCallback}
                                    register={register}
                                    className={className}
                                    {...otherProps}
                                />

                                {errorText && <Form.Control.Feedback type="invalid" className="d-block">
                                    {errorText}
                                </Form.Control.Feedback>}
                            </Form.Group>
                        </>
                    ) : (
                        <>
                            {type === 'checkbox' || type === 'radio' ? (
                                <>
                                    <Form.Group className={containerClass}>
                                        <Form.Check
                                            type={type}
                                            label={label}
                                            name={name}
                                            id={name}
                                            ref={(r: HTMLInputElement) => {
                                                if (refCallback) refCallback(r);
                                            }}
                                            className={className + 'align-middle'}
                                            {...(register ? register(name) : {})}
                                            {...otherProps}
                                        />

                                        {errorText && <Form.Control.Feedback type="invalid" className="d-block">
                                            {errorText}
                                        </Form.Control.Feedback>}
                                    </Form.Group>
                                </>
                            ) : (type === 'select' ?
                                <Form.Group className={containerClass}>
                                    {label ? <Form.Label className={labelClassName}>{label}</Form.Label> : null}

                                    <Form
                                        type={type}
                                        placeholder={placeholder}
                                        name={name}
                                        id={name}
                                        as={comp}
                                        ref={(r: HTMLInputElement) => {
                                            if (refCallback) refCallback(r);
                                        }}
                                        className={'form-control'}
                                        {...(register ? register(name) : {})}
                                        rows={rows}
                                        {...otherProps}
                                        autoComplete={name}
                                    >
                                        {children ? children : null}
                                    </Form>

                                    {errorText && <Form.Control.Feedback type="invalid" className="d-block">
                                        {errorText}
                                    </Form.Control.Feedback>}
                                </Form.Group>
                                :
                                <Form.Group className={containerClass}>
                                    {label ? <Form.Label className={labelClassName}>{label}</Form.Label> : null}

                                    <Form.Control
                                        type={type}
                                        placeholder={placeholder}
                                        name={name}
                                        id={name}
                                        as={comp}
                                        ref={(r: HTMLInputElement) => {
                                            if (refCallback) refCallback(r);
                                        }}
                                        className={className}
                                        {...(register ? register(name) : {})}
                                        rows={rows}
                                        {...otherProps}
                                        autoComplete={name}
                                    >
                                        {children ? children : null}
                                    </Form.Control>

                                    {errorText && <Form.Control.Feedback type="invalid" className="d-block">
                                        {errorText}
                                    </Form.Control.Feedback>}
                                </Form.Group>
                            )}
                        </>
                    )}
                </>
            )}
        </>
    );
};

export default FormInput;
